function n(n){return new RegExp("^("+n.join("|")+")\\b","i")}export{n as getSvgRegex};
//# sourceMappingURL=getSvgRegex.min.mjs.map
